const getAverageRating = (rating, includeAbbreviation = false) => {
  if (rating > 0) {
    return `${includeAbbreviation ? 'Avg' : ''} ${rating.toFixed(1)}`;
  }
  return null;
};

export default getAverageRating;
